const cardsDataH = [
  {
    label: 'Diseño de actividad',
    tagType: 'd_activity',
    imgSrc: 'img/Workflow.png',
    link: '/design-activity',
    description: '<strong class="small-text">Fecha de creación:</strong><br /> 21 de noviembre de 2023<br /><br /><strong class="small-text">Nombre:</strong><br /><p class="text-truncate">Diseño de actividad para fracciones.</p>',
    btnLabel: 'Editar',
  },
  {
    label: 'Diseño de clase',
    tagType: 'd_class',
    imgSrc: 'img/Workflow.png',
    link: '/design-activity',    
    description: '<strong class="small-text">Fecha de creación:</strong><br /> 21 de noviembre de 2023<br /><br /><strong class="small-text">Nombre:</strong><br /><p class="text-truncate">Diseño de clase para fracciones.</p>',
    btnLabel: 'Editar',
  },
  {
    label: 'Diseño de evaluación',
    tagType: 'd_assess',
    imgSrc: 'img/Workflow.png',
    link: '/design-activity',
    description: '<strong class="small-text">Fecha de creación:</strong><br /> 21 de noviembre de 2023<br /><br /><strong class="small-text">Nombre:</strong><br /><p class="text-truncate">Diseño de evaluación para fracciones.</p>',
    btnLabel: 'Editar',
  },
];

export default cardsDataH;
